"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Step = _interopRequireDefault(require("./Step"));

var _utils = require("./utils");

var _colors = require("./colors");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// listed from most severe to least
var stylePriority = ['danger', 'warning', 'none', 'success']; // map of style to its priority, 0 is highest priority

var priorityMap = stylePriority.reduce(function (agg, curr, index) {
  agg[curr] = index; // eslint-disable-line no-param-reassign

  return agg;
}, {});

var StepGroup =
/*#__PURE__*/
function (_Component) {
  _inherits(StepGroup, _Component);

  function StepGroup() {
    _classCallCheck(this, StepGroup);

    return _possibleConstructorReturn(this, _getPrototypeOf(StepGroup).apply(this, arguments));
  }

  _createClass(StepGroup, [{
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          children = _this$props.children,
          active = _this$props.active,
          partial = _this$props.partial,
          completed = _this$props.completed,
          connectorColor = _this$props.connectorColor,
          activeSubStep = _this$props.activeSubStep;
      var overrideBsStyle = this.props.overrideBsStyle; // get all sub-step overrideBsStyles (Children.map can return null or undefined)

      var overrides = _react.Children.map(children, function (child) {
        return child.props.overrideBsStyle;
      }); // find the most severe style that is being passed to the sub-steps by sorting based on style priority


      var mostSevereOverride = overrides ? overrides.filter(function (o) {
        return o;
      }).map(function (o) {
        return priorityMap[o];
      }).sort().map(function (p) {
        return stylePriority[p];
      })[0] : undefined;

      if (mostSevereOverride) {
        overrideBsStyle = mostSevereOverride;
      }

      var renderedConnectorColor = connectorColor;

      if (completed && overrideBsStyle) {
        renderedConnectorColor = (0, _utils.mapBsStyleToColor)(overrideBsStyle, {
          fallback: _colors.alloy
        });
      }

      return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement(_Step["default"], _extends({}, this.props, {
        overrideBsStyle: overrideBsStyle,
        index: this.props.index.toString()
      }), this.props.contents), _react["default"].createElement("div", {
        style: {
          borderLeft: "2px dotted ".concat(renderedConnectorColor),
          margin: '4px 0 4px 9px',
          paddingLeft: '9px',
          flexDirection: 'column'
        }
      }, _react.Children.map(children, function (step, index) {
        var controlProps = {
          activeColor: _this.props.activeColor,
          small: true,
          vertical: true,
          index: "".concat(_this.props.index, ".").concat(index)
        };

        if (active && activeSubStep === index) {
          controlProps.active = true;
          controlProps.partial = partial;
        } else if (completed || active && activeSubStep > index) {
          controlProps.completed = true;
        }

        return _react["default"].cloneElement(step, _objectSpread({}, controlProps, {}, step.props));
      })));
    }
  }]);

  return StepGroup;
}(_react.Component);

exports["default"] = StepGroup;

_defineProperty(StepGroup, "propTypes", {
  active: _propTypes["default"].bool,
  partial: _propTypes["default"].bool,
  completed: _propTypes["default"].bool,
  activeSubStep: _propTypes["default"].number,
  contents: _propTypes["default"].node,
  connectorColor: _propTypes["default"].string,
  index: _propTypes["default"].number,
  activeColor: _propTypes["default"].string,
  overrideBsStyle: _propTypes["default"].oneOf(stylePriority),
  children: _propTypes["default"].node
});

_defineProperty(StepGroup, "defaultProps", {
  index: 0
});